import './integration-card.scss';
import Card from '../../../../../components/layouts/card/card';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { ButtonIcon } from '../../../../../components/inputs/button-icon/button-icon';
import IconDelete from '../../../../../components/icons/icon-delete/icon-delete';
import integrationListStore from '../../stores/integrations-list-store';
import { BUTTON_VARIANTS } from '../../../../../components/inputs/button-variants';
import { Button } from '../../../../../components/inputs/button/button';
import { Toggle } from '../../../../../components/inputs/toggle/toggle';
import useValidationGroup, { IValidationGroup } from '../../../../../hooks/validation-group/validation-group-hook';
import GorgiasAppCredentials from '../credentials/gorgias-app-credentials/gorgias-app-credentials';
import GorgiasAppCredentialsStore from '../../stores/credentials/gorgias-app-credentials-store';
import GorgiasCredentials from '../credentials/gorgias-credentials/gorgias-credentials';
import GorgiasCredentialsStore from '../../stores/credentials/gorgias-credentials-store';
import IconDisconnect from '../../../../../components/icons/icon-disconnect/icon-disconnect';
import IconSave from '../../../../../components/icons/icon-save/icon-save';
import IntegrationAction from '../integration-action/integration-action';
import { Badge, BadgeType } from '../../../../../components/badge/badge';
import ActionsDisabledOverlay from '../actions-disabled-overlay/actions-disabled-overlay';
import { INTEGRATION_CODE, INTEGRATION_NAME_MAP, SHIPPING_CONNECTION_CODE, STRIPE_ERROR, INTEGRATION_CATEGORY } from '../../../../../models/IntegrationsTypes';
import { IIntegrationStore, INTEGRATION_STORE_TYPE } from '../../stores/integration-store';
import ZendeskCredentials from '../credentials/zendesk-credentials/zendesk-credentials';
import ZendeskCredentialsStore from '../../stores/credentials/zendesk-credentials-store';
import ShipedgeCredentials from '../credentials/shipedge-credentials/shipedge-credentials';
import ShipedgeCredentialsStore from '../../stores/credentials/shipedge-credentials-store';
import RefundidCredentials from '../credentials/refundid-credentials/refundid-credentials';
import ReveniCredentialsStore from '../../stores/reveni-credentials-store';
import ReveniCredentials from '../credentials/reveni-credentials/reveni-credentials';
import NetSuiteCredentials from "../credentials/net-suite-credentials/net-suite-credentials";
import NetSuiteCredentialsStore from "../../stores/credentials/net-suite-credentials-store";
import PicqerCredentials from "../credentials/picqer-credentials/picqer-credentials";
import PicqerCredentialsStore from "../../stores/credentials/picqer-credentials-store";
import TrengoCredentials from "../credentials/trengo-credentials/trengo-credentials";
import TrengoCredentialsStore from "../../stores/credentials/trengo-credentials-store";
import ShipheroCredentialsStore from '../../stores/credentials/shiphero-credentials-store';
import ShipheroCredentials from '../credentials/shiphero-credentials/shiphero-credentials';
import PeoplevoxCredentialsStore from '../../stores/credentials/peoplevox-credentials-store';
import PeoplevoxCredentials from '../credentials/peoplevox-credentials/peoplevox-credentials';
import KlaviyoCredentialsStore from '../../stores/credentials/klaviyo-credentials-store';
import KlaviyoCredentials from '../credentials/klaviyo-credentials/klaviyo-credentials';
import ReamazeCredentials from '../credentials/reamaze-credentials/reamaze-credentials';
import ReamazeCredentialsStore from '../../stores/credentials/reamaze-credentials-store';
import RiseCredentials from '../credentials/rise-credentials/rise-credentials';
import { NotificationModal } from '../../../../../components/modal/components/notification-modal/notification-modal';
import ActionConfirmModal from '../action-confirm-modal/action-confirm-modal';
import BrightpearlCredentials from '../credentials/brightpearl-credentials/brightpearl-credentials';
import FreshdeskCredentialsStore from '../../stores/credentials/freshdesk-credentials-store';
import FreshdeskCredentials from '../credentials/freshdesk-credentials/freshdesk-credentials';
import ApiSecretCredentialsStore from '../../stores/credentials/shipping/api-secret-credentials-store';
import ApiSecretCredentials from '../credentials/shipping/api-secret-credentials/api-secret-credentials';
import CustomerNumberCredentials from '../credentials/shipping/customer-number-credentials/customer-number-credentials';
import CustomerNumberCredentialsStore from '../../stores/credentials/shipping/customer-number-credentials-store';
import ApiKeyCredentials from '../credentials/shipping/api-key-credentials/api-key-credentials';
import ApiKeyCredentialsStore from '../../stores/credentials/shipping/api-key-credentials-store';
import IntersoftCredentials from '../credentials/shipping/intersoft-credentials/intersoft-credentials';
import IntersoftCredentialsStore from '../../stores/credentials/shipping/intersoft-credentials-store';
import WebshipperCredentials from '../credentials/shipping/webshipper-credentials/webshipper-credentials';
import WebshipperCredentialsStore from '../../stores/credentials/shipping/webshipper-credentials-store';
import MintsoftCredentialsStore from '../../stores/credentials/mintsoft-credentials-store';
import MintsoftCredentials from '../credentials/mintsoft-credentials/mintsoft-credentials';
import { Tooltip, TOOLTIP_VARIANTS } from '../../../../../components/tooltip/tooltip';
import CanadaPostCredentials from '../credentials/shipping/canada-post-credentials/canada-post-credentials';
import UspsDirectOauthCredentials from '../credentials/shipping/usps-direct-oauth-credentials/usps-direct-oauth-credentials';
import UspsDirectOauthCredentialsStore from '../../stores/credentials/shipping/usps-direct-oauth-credentials-store';
import Cin7Credentials from '../credentials/cin7-credentials/cin7-credentials';
import Cin7CredentialsStore from '../../stores/credentials/cin7-credentials-store';
import AimsCredentials from '../credentials/aims-credentials/aims-credentials';
import AimsCredentialsStore from '../../stores/credentials/aims-credentials-store';
import MondialRelayCredentials from '../credentials/shipping/mondial-relay-credentials/mondial-relay-credentials';
import MondialRelayCredentialsStore from '../../stores/credentials/shipping/mondial-relay-credentials-store';
import ReboundCredentials from '../credentials/shipping/rebound-credentials/rebound-credentials';
import ReboundCredentialsStore from '../../stores/credentials/shipping/rebound-credentials-store';
import DhlCredentialsStore from "../../stores/credentials/shipping/dhl-credentials-store";
import DhlCredentials from "../credentials/shipping/dhl-credentials/dhl-credentials";
import RlmCredentials from "../credentials/rlm-credentials/rlm-credentials";
import RlmCredentialsStore from "../../stores/credentials/rlm-credentials-store";
import BrightpearlOauthCredentialsStore from "../../stores/credentials/brightpearl-credentials-store";
import BergenCredentials from "../credentials/bergen-credentials/bergen-credentials";
import BergenCredentialsStore from "../../stores/credentials/bergen-credentials-store";
import React from 'react';
import ConnectionNameField from '../connection-name-field/connection-name-field';
import WhiplashCredentials from "../credentials/whiplash-credentials/whiplash-credentials";
import WhiplashOauthCredentialsStore from "../../stores/credentials/whiplash-credentials-store";
import AmazonMcfCredentials from "../credentials/amazon-mcf-credentials/amazon-mcf-credentials";
import AmazonMcfCredentialsStore from "../../stores/credentials/amazon-mcf-credentials-store";
import Apparel21Credentials from "../credentials/apparel21-credentials/apparel21-credentials";
import Apparel21CredentialsStore from "../../stores/credentials/apparel21-credentials-store";
import IconSolidLock from "../../../../../components/icons/icon-solid-lock/icon-solid-lock";
import SendcloudReturnsCredentials
    from "../credentials/shipping/sendcloud-returns-credentials/sendcloud-returns-credentials";
import SendcloudReturnsCredentialsStore from "../../stores/credentials/shipping/sendcloud-returns-credentials-store";
import FedexCredentialsStore from "../../stores/credentials/shipping/fedex-credentials-store";
import FedexCredentials from "../credentials/shipping/fedex-dredentials/fedex-credentials";
import FedexV2CredentialsStore from "../../stores/credentials/shipping/fedex-v2/fedex-v2-credentials-store";
import FedexV2Credentials from "../credentials/shipping/fedex-v2-credentials/fedex-v2-credentials";
import InventoryTrackingConnectionNote from "../inventory-tracking-connection-note";
import ShipmonkCredentialsStore from "../../stores/credentials/shipmonk-credentials-store";
import ShipmonkCredentials from "../credentials/shipmonk-credentials/shipmonk-credentials";
import IsSandboxField from "../credentials/fields/is-sandbox-field";
import EdnCredentials from "../credentials/shipping/edn-credentials/edn-credentials";
import EnvoiDuNetCredentialsStore from "../../stores/credentials/shipping/edn-credentials-store";
import DeposcoCredentials from "../credentials/deposco-credentials/deposco-credentials";
import DeposcoCredentialsStore from '../../stores/credentials/deposco-credentials-store';
import LabelGOCredentials from "../credentials/shipping/labelgo-credentials/labelgo-credentials";
import LabelGOCredentialsStore from "../../stores/credentials/shipping/labelgo-credentials-store";
import YodelCredentials from "../credentials/shipping/yodel-credentials/yodel-credentials";
import YodelCredentialsStore from "../../stores/credentials/shipping/yodel-credentials-store";
import SalasaCredentials from "../credentials/shipping/salasa-credentials/salasa-credentials";
import SalasaCredentialsStore from "../../stores/credentials/shipping/salasa-credentials-store";
import AggregatorsInfoStore from '../../../../return-methods/stores/aggregators-info-store';
import DhlDeReturnsCredentialsStore from '../../stores/credentials/shipping/dhl-de-returns-credentials-store';
import DhlDeReturnsCredentials from '../credentials/shipping/dhl-de-returns-credentials/dhl-de-returns-credentials';
import EasyshipCredentials from "../credentials/shipping/easyship-credentials/easyship-credentials";
import EasyshipCredentialsStore from "../../stores/credentials/shipping/easyship-credentials-store";
import ZendeskOAuthCredentialsStore from "../../stores/credentials/zendesk-oauth-credentials-store";
import ZendeskOauthCredentials from "../credentials/zendesk-oauth-credentials/zendesk-oauth-credentials";
import KExpressCredentials from "../credentials/shipping/k-express-credentials/k-express-credentials";
import KExpressCredentialsStore from "../../stores/credentials/shipping/k-express-credentials-store";
import ZigZagCredentials from '../credentials/shipping/zigzag-credentials/zigzag-credentials';
import ZigZagCredentialsStore from '../../stores/credentials/shipping/zigzag-credentials-store';
import AdyenBasicCredentials from "../credentials/adyen-basic-credentials/adyen-basic-credentials";
import AdyenBasicCredentialsStore from "../../stores/credentials/adyen-basic-credentials-store";
import AdyenOauthCredentialsStore from "../../stores/credentials/adyen-oauth-credentials-store";
import AdyenOAuthCredentials from '../credentials/adyen-oauth-credentials/adyen-oauth-credentials';
import BraintreeCredentials from '../credentials/braintree-credentials/braintree-credentials';
import BraintreeCredentialsStore from '../../stores/credentials/braintree-credentials-store';
import CustomDynamicLocationCredentials
    from '../credentials/custom-dynamic-location-credentials/custom-dynamic-location-credentials';
import CustomDynamicLocationCredentialsStore from '../../stores/credentials/custom-dynamic-location-credentials-store';
import CybersourceCredentials from '../credentials/cybersource-credentials/cybersource-credentials';
import CybersourceCredentialsStore from '../../stores/credentials/cybersource-credentials-store';
import GlobalECredentials from '../credentials/shipping/global-e-credentials/global-e-credentials';
import GlobalECredentialsStore from '../../stores/credentials/shipping/global-e-credentials-store';
import DpdUKCredentials from "../credentials/shipping/dpd-uk-credentials/dpd-uk-credentials";
import DpdUkCredentialsStore from "../../stores/credentials/shipping/dpd-uk-credentials-store";
import DeliverrCredentials from "../credentials/deliverr-credentials/deliverr-credentials";
import DeliverrCredentialsStore from "../../stores/credentials/deliverr-credentials-store";

const images = import.meta.glob<{ default: string }>('../../../../../images/*.svg', { eager: true });

interface IIntegrationProps {
    integration: IIntegrationStore,
    aggregatorsInfoStore?: AggregatorsInfoStore,
    isExpandable?: boolean,
    isExpanded?: boolean,
    isButtonDisabled: boolean,
}

const getSpecificComponent = (integration: IIntegrationStore, vGroup: IValidationGroup) => {
    switch (integration.serviceCode) {
        case INTEGRATION_CODE.GORGIAS:
            return <GorgiasCredentials credentialsStore={integration.credentialsStore as GorgiasCredentialsStore} vGroup={vGroup} />;
        case INTEGRATION_CODE.GORGIAS_APP:
            return <GorgiasAppCredentials credentialsStore={integration.credentialsStore as GorgiasAppCredentialsStore} vGroup={vGroup} />;
        case INTEGRATION_CODE.ZENDESK:
            return <ZendeskCredentials credentialsStore={integration.credentialsStore as ZendeskCredentialsStore} vGroup={vGroup} />;
        case INTEGRATION_CODE.ZENDESK_OAUTH:
            return <ZendeskOauthCredentials credentialsStore={integration.credentialsStore as ZendeskOAuthCredentialsStore} vGroup={vGroup} />;
        case INTEGRATION_CODE.DELIVERR:
            return <DeliverrCredentials credentialsStore={integration.credentialsStore as DeliverrCredentialsStore} vGroup={vGroup} />;
        case INTEGRATION_CODE.SHIPBOB:
        case INTEGRATION_CODE.STRIPE:
            return <></>;
        case INTEGRATION_CODE.AMAZON_MCF:
            return <AmazonMcfCredentials credentialsStore={integration.credentialsStore as AmazonMcfCredentialsStore} vGroup={vGroup}/>;
        case INTEGRATION_CODE.NET_SUITE:
            return <NetSuiteCredentials credentialsStore={integration.credentialsStore as NetSuiteCredentialsStore} vGroup={vGroup} />;
        case INTEGRATION_CODE.REFUNDID:
            return <RefundidCredentials isShowRegister={integration.serviceType === 'instant-refund' && !!integration?.shouldRegister} />;
        case INTEGRATION_CODE.SHIPEDGE:
            return <ShipedgeCredentials credentialsStore={integration.credentialsStore as ShipedgeCredentialsStore} vGroup={vGroup} />;
        case INTEGRATION_CODE.REVENI:
            return <ReveniCredentials credentialsStore={integration.credentialsStore as ReveniCredentialsStore} vGroup={vGroup} />;
        case INTEGRATION_CODE.PICQER:
            return <PicqerCredentials credentialsStore={integration.credentialsStore as PicqerCredentialsStore} vGroup={vGroup} />;
        case INTEGRATION_CODE.SHIPHERO:
            return <ShipheroCredentials credentialsStore={integration.credentialsStore as ShipheroCredentialsStore} vGroup={vGroup} />;
        case INTEGRATION_CODE.TRENGO:
            return <TrengoCredentials credentialsStore={integration.credentialsStore as TrengoCredentialsStore} vGroup={vGroup} />
        case INTEGRATION_CODE.PEOPLEVOX:
            return <PeoplevoxCredentials credentialsStore={integration.credentialsStore as PeoplevoxCredentialsStore} vGroup={vGroup} />
        case INTEGRATION_CODE.KLAVIYO:
            return <KlaviyoCredentials credentialsStore={integration.credentialsStore as KlaviyoCredentialsStore} vGroup={vGroup} />
        case INTEGRATION_CODE.REAMAZE:
            return <ReamazeCredentials credentialsStore={integration.credentialsStore as ReamazeCredentialsStore} vGroup={vGroup} />;
        case INTEGRATION_CODE.RISE:
            return <RiseCredentials />;
        case INTEGRATION_CODE.BRIGHTPEARL:
            return <BrightpearlCredentials credentialsStore={integration.credentialsStore as BrightpearlOauthCredentialsStore} vGroup={vGroup} />;
        case INTEGRATION_CODE.WHIPLASH:
            return <WhiplashCredentials credentialsStore={integration.credentialsStore as WhiplashOauthCredentialsStore} vGroup={vGroup} />;
        case INTEGRATION_CODE.FRESHDESK:
            return <FreshdeskCredentials credentialsStore={integration.credentialsStore as FreshdeskCredentialsStore} vGroup={vGroup} />
        case INTEGRATION_CODE.BERGEN:
            return <BergenCredentials credentialsStore={integration.credentialsStore as BergenCredentialsStore} vGroup={vGroup} />
        case INTEGRATION_CODE.DEPOSCO:
            return <DeposcoCredentials credentialsStore={integration.credentialsStore as DeposcoCredentialsStore} vGroup={vGroup} />
        case SHIPPING_CONNECTION_CODE.SHIPPO:
        case SHIPPING_CONNECTION_CODE.SHIPPY_PRO:
        case SHIPPING_CONNECTION_CODE.PARCEL_NINJA:
        case SHIPPING_CONNECTION_CODE.EASY_POST:
        case SHIPPING_CONNECTION_CODE.SEKO:
        case SHIPPING_CONNECTION_CODE.SHIPSTATION_V2:
            return <ApiKeyCredentials
                credentialsStore={integration.credentialsStore as ApiKeyCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.SENDCLOUD:
            return <ApiSecretCredentials
                credentialsStore={integration.credentialsStore as ApiSecretCredentialsStore}
                vGroup={vGroup}
                apiKeyLabel='Public Key'
                apiKeyNote='Public key for this account'
                apiSecretLabel='Secret Key'
                apiSecretNote='Secret key for this account'
            />
        case SHIPPING_CONNECTION_CODE.SHIPMONDO:
            return <ApiSecretCredentials
                credentialsStore={integration.credentialsStore as ApiSecretCredentialsStore}
                vGroup={vGroup}
                apiKeyLabel='API User'
                apiKeyNote='API User for this account'
                apiSecretLabel='API Key'
                apiSecretNote='API key for this account'
            />
        case SHIPPING_CONNECTION_CODE.SHIP_STATION:
            return <ApiSecretCredentials
                credentialsStore={integration.credentialsStore as ApiSecretCredentialsStore}
                vGroup={vGroup}
                apiKeyLabel='API Key'
                apiKeyNote='API key for this account'
                apiSecretLabel='API secret'
                apiSecretNote='API secret for this account (if applicable)'
            />
        case SHIPPING_CONNECTION_CODE.STARSHIPIT:
        case SHIPPING_CONNECTION_CODE.NZ_POST_ESHIP:
            return <ApiSecretCredentials
                credentialsStore={integration.credentialsStore as ApiSecretCredentialsStore}
                vGroup={vGroup}
                apiKeyLabel='API Key'
                apiKeyNote='Your API key'
                apiSecretLabel='Subscription Key'
                apiSecretNote='Your subscription key'
            />
        case SHIPPING_CONNECTION_CODE.USPS:
            return <ApiSecretCredentials
                credentialsStore={integration.credentialsStore as ApiSecretCredentialsStore}
                vGroup={vGroup}
                apiKeyLabel='Account Code'
                apiKeyNote='Your USPS "Merchant Account Code" (not account ID)'
                apiSecretLabel='Mailer ID'
                apiSecretNote='The mailer ID from your USPS account, corresponding to the address for returns'
            />
        case SHIPPING_CONNECTION_CODE.AUSTRALIA_POST:
            return <CustomerNumberCredentials
                credentialsStore={integration.credentialsStore as CustomerNumberCredentialsStore}
                vGroup={vGroup}
                apiKeyNote='Your Australia Post API key (username)'
                apiSecretNote='Your Australia Post API password (secret)'
                customerNumberNote='Your Australia Post eParcel and International Account Number'
            />
        case SHIPPING_CONNECTION_CODE.CANADA_POST:
            return <CanadaPostCredentials />
        case SHIPPING_CONNECTION_CODE.USPS_DIRECT_OAUTH:
            return <UspsDirectOauthCredentials
                credentialsStore={integration.credentialsStore as UspsDirectOauthCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.CARGO:
            return <CustomerNumberCredentials
                credentialsStore={integration.credentialsStore as CustomerNumberCredentialsStore}
                vGroup={vGroup}
                apiKeyLabel='Cargo username'
                apiKeyNote='Your Cargo username'
                apiSecretLabel='Cargo password'
                apiSecretNote='Cargo password for this account'
                customerNumberLabel='Customer code'
                customerNumberNote='Your Cargo customer code for selected cargo service'
            />
        case SHIPPING_CONNECTION_CODE.DHL_EXPRESS:
            return <DhlCredentials
                credentialsStore={integration.credentialsStore as DhlCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.INTERSOFT:
            return <IntersoftCredentials
                credentialsStore={integration.credentialsStore as IntersoftCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.WEBSHIPPER:
            return <WebshipperCredentials
                credentialsStore={integration.credentialsStore as WebshipperCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.FEDEX:
            return <FedexCredentials
                credentialsStore={integration.credentialsStore as FedexCredentialsStore}
                vGroup={vGroup}
                apiKeyLabel='FedEx Webservice account number'
                apiKeyNote='Your FedEx account number for shipment API'
            />
        case SHIPPING_CONNECTION_CODE.FEDEX_V2:
            return <FedexV2Credentials
                credentialsStore={integration.credentialsStore as FedexV2CredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.MONDIAL_RELAY:
            return <MondialRelayCredentials
                credentialsStore={integration.credentialsStore as MondialRelayCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.HAPPY_RETURNS:
            return <ApiKeyCredentials
                credentialsStore={integration.credentialsStore as ApiKeyCredentialsStore}
                vGroup={vGroup}
                apiKeyLabel='Retailer ID'
                apiKeyNote='Retailer ID for this account'
            />
        case SHIPPING_CONNECTION_CODE.REBOUND:
            return <ReboundCredentials
                credentialsStore={integration.credentialsStore as ReboundCredentialsStore}
                vGroup={vGroup}
            />
        case INTEGRATION_CODE.MINTSOFT:
            return <MintsoftCredentials
                credentialsStore={integration.credentialsStore as MintsoftCredentialsStore}
                vGroup={vGroup}
            />
        case INTEGRATION_CODE.CIN7:
            return <Cin7Credentials
                credentialsStore={integration.credentialsStore as Cin7CredentialsStore}
                vGroup={vGroup}
            />
        case INTEGRATION_CODE.AIMS:
            return <AimsCredentials
                credentialsStore={integration.credentialsStore as AimsCredentialsStore}
                vGroup={vGroup}
            />
        case INTEGRATION_CODE.RLM:
            return <RlmCredentials
                credentialsStore={integration.credentialsStore as RlmCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.CORREOS:
            return <CustomerNumberCredentials
                credentialsStore={integration.credentialsStore as CustomerNumberCredentialsStore}
                vGroup={vGroup}
                apiKeyLabel='Correos username'
                apiKeyNote='Enter Correos username'
                apiSecretLabel='Correos password'
                apiSecretNote='Enter Correos password'
                customerNumberLabel='Correos customer code'
                customerNumberNote='Enter the Correos customer code (CodEtiquetador)'
            />
        case SHIPPING_CONNECTION_CODE.INPOST_UK:
            return <ApiSecretCredentials
                credentialsStore={integration.credentialsStore as ApiSecretCredentialsStore}
                vGroup={vGroup}
                apiKeyLabel='InPost UK client ID'
                apiKeyNote='Username of your email, e.g.: returngo if your email is returngo@inpost.pl'
                apiSecretLabel='InPost UK API key'
                apiSecretNote='Bearer token provided by InPost UK'
            />
        case INTEGRATION_CODE.APPAREL21:
            return <Apparel21Credentials
                credentialsStore={integration.credentialsStore as Apparel21CredentialsStore}
                vGroup={vGroup}
            />;
        case SHIPPING_CONNECTION_CODE.SENDCLOUD_RETURNS:
            return <SendcloudReturnsCredentials
                credentialsStore={integration.credentialsStore as SendcloudReturnsCredentialsStore}
                vGroup={vGroup}
            />;
        case SHIPPING_CONNECTION_CODE.VESYL:
            return <ApiKeyCredentials
                credentialsStore={integration.credentialsStore as ApiKeyCredentialsStore}
                vGroup={vGroup}
                apiKeyLabel='API key'
                apiKeyNote='Vesyl API key'
            />
        case SHIPPING_CONNECTION_CODE.THE_RETURN:
        case INTEGRATION_CODE.YOTPO:
        case INTEGRATION_CODE.TRACKSTAR:
        case INTEGRATION_CODE.RISE_AI_OAUTH:
            return <></>;
        case INTEGRATION_CODE.SHIPMONK:
            return <ShipmonkCredentials
                credentialsStore={integration.credentialsStore as ShipmonkCredentialsStore}
                vGroup={vGroup}
            />
        case INTEGRATION_CODE.CUSTOM_DYNAMIC_LOCATION:
            return <CustomDynamicLocationCredentials
                credentialsStore={integration.credentialsStore as CustomDynamicLocationCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.ENVOI_DU_NET:
            return <EdnCredentials
                credentialsStore={integration.credentialsStore as EnvoiDuNetCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.LABELGO:
            return <LabelGOCredentials
                credentialsStore={integration.credentialsStore as LabelGOCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.YODEL:
            return <YodelCredentials
                credentialsStore={integration.credentialsStore as YodelCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.SALASA:
            return <SalasaCredentials
                credentialsStore={integration.credentialsStore as SalasaCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.DHL_DE_RETURNS:
            return <DhlDeReturnsCredentials
                credentialsStore={integration.credentialsStore as DhlDeReturnsCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.EASYSHIP:
            return <EasyshipCredentials
                credentialsStore={integration.credentialsStore as EasyshipCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.K_EXPRESS:
            return <KExpressCredentials
                credentialsStore={integration.credentialsStore as KExpressCredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.ZIGZAG:
            return <ZigZagCredentials
              credentialsStore={integration.credentialsStore as ZigZagCredentialsStore}
              vGroup={vGroup}
            />
        case INTEGRATION_CODE.ADYEN_BASIC:
            return <AdyenBasicCredentials
                credentialsStore={integration.credentialsStore as AdyenBasicCredentialsStore}
                vGroup={vGroup}
            />
        case INTEGRATION_CODE.ADYEN:
            return <AdyenOAuthCredentials
                credentialsStore={integration.credentialsStore as AdyenOauthCredentialsStore}
                vGroup={vGroup}
            />
        case INTEGRATION_CODE.BRAINTREE:
            return <BraintreeCredentials
                credentialsStore={integration.credentialsStore as BraintreeCredentialsStore}
                vGroup={vGroup}
            />
        case INTEGRATION_CODE.CYBERSOURCE:
            return <CybersourceCredentials
                credentialsStore={integration.credentialsStore as CybersourceCredentialsStore}
                vGroup={vGroup}
            />
        case INTEGRATION_CODE.GLOBAL_E:
        case SHIPPING_CONNECTION_CODE.GLOBAL_E:
            return <GlobalECredentials
                credentialsStore={integration.credentialsStore as GlobalECredentialsStore}
                vGroup={vGroup}
            />
        case SHIPPING_CONNECTION_CODE.DPD_UK:
            return <DpdUKCredentials
                credentialsStore={integration.credentialsStore as DpdUkCredentialsStore}
                vGroup={vGroup}
            />
        default: throw new Error('Not implemented.');
    }
};

const getConnectedLayout = (integration: IIntegrationStore, vGroup: IValidationGroup) => {
    return (
        <>
            <ConnectionNameField
                value={integration.internalName}
                onChange={integration.setInternalName}
                validationGroup={vGroup}
                name={INTEGRATION_NAME_MAP[integration.serviceCode]?.name || integration.serviceCode}
                isShipping={integration.type === INTEGRATION_STORE_TYPE.SHIPPING}
            />
            {!!integration.integrationSettingsStores?.length && (
                integration.integrationSettingsStores?.map(store => {
                    return <IntegrationAction
                        vGroup={vGroup}
                        actionStore={store}
                        key={store.label + store.type}
                        isDisabled={!integration.isAllowed}
                    />
                })
            )}
        </>
    );
};

const getCardToolbarSaveButton = (integration: IIntegrationStore, onClick: () => Promise<void>) => {
    if (!integration.id) {
        return null;
    }
    return (
        <>
            <ButtonIcon Component={IconSave} onClick={onClick} disabled={!integration.hasChanges?.()} />
            {integration.hasChanges?.() && <Badge text="unsaved" type={BadgeType.WARNING} />}
        </>
    )
}


const logoSrc = (integration: IIntegrationStore, aggregatorsInfoStore: AggregatorsInfoStore | undefined) => {
    if (integration.isShipping) {

        if (!aggregatorsInfoStore) {
            return undefined;
        }

        // integration.serviceCode is of type that is served for both shipping and regular integrations
        // so we have to hint Typescript to treat it as we know it is in this case (shipping integration)
        // if you have a better way - don't hesitate to raise it in the next team meeting and improve our codebase FTW
        return aggregatorsInfoStore.getLogoIconUrl(integration.serviceCode as SHIPPING_CONNECTION_CODE);
    }

    try {
        return images[`../../../../../images/${integration.serviceCode}.svg`].default;
    }
    catch (err) {
        return images["../../../../../images/defaultIntegrationLogo.svg"].default;
    }
};

const IntegrationCard: React.FC<IIntegrationProps> = observer(({ integration, isExpandable = true, aggregatorsInfoStore, isExpanded = true, isButtonDisabled }) => {
    const vGroup = useValidationGroup();
    const [isShowDeleteConfirmModal, setIsShowDeleteConfirmModal] = useState(false);
    const [isShowForgetConfirmModal, setIsShowForgetConfirmModal] = useState(false);
    const [isShowNotificationModal, setIsShowNotificationModal] = useState(false);
    const [isShowStripeModal, setIsShowStripeModal] = useState(false);
    const [isInventoryTrackingNoteVisible, setIsInventoryTrackingNoteVisible] = useState(false);


    const onConnect = async () => {
        if (integration.serviceType === INTEGRATION_CATEGORY.INVENTORY_TRACKING) {
            setIsInventoryTrackingNoteVisible(true);
        }
        const res = await integration.register();
        /** spacial case for stripe error */
        if (res === STRIPE_ERROR.ACTIVATE_ACCOUNT) {
            setIsShowStripeModal(true);
        }
    };

    const onDelete = () => {
        if (!integration.deleteInfo.can_be_deleted) {
            setIsShowNotificationModal(true);
        } else {
            setIsShowDeleteConfirmModal(true);
        }
    }

    const onDeleteConfirm = async () => {
        setIsShowDeleteConfirmModal(false);
        await integrationListStore.removeIntegration(integration);
    };

    const onForget = async () => {
        if (!integration.deleteInfo.can_be_deleted) {
            setIsShowNotificationModal(true);
        } else {
            setIsShowDeleteConfirmModal(true);
        }
    };

    const onForgetConfirm = async () => {
        setIsShowForgetConfirmModal(false);
        try {
            await integration.forget();
        } catch (e) { } // plug
    };

    const onUpdate = async () => {
        await integration.update?.();
    };

    return (
        <>
            <Card
                toolbar={{
                    title: (
                        <div className='integration-title'>
                            <img src={logoSrc(integration, aggregatorsInfoStore)} alt='service logo' className='integration-logo' />
                            <span>{integration.label}</span>
                            {integration.id && <Tooltip content='Disconnect integration'>
                                <ButtonIcon Component={IconDisconnect} disabled={isButtonDisabled || integration.isLoading} onClick={onForget} />
                            </Tooltip>}
                        </div>
                    ),
                    content: (
                        <>
                            {getCardToolbarSaveButton(integration, onUpdate)}
                            <Tooltip content='Delete integration'>
                                <ButtonIcon Component={IconDelete} disabled={isButtonDisabled || integration.isLoading} onClick={() => onDelete()} />
                            </Tooltip>
                            {!integration.isAllowed &&
                                <Tooltip variant={TOOLTIP_VARIANTS.TEXT} content= "Sorry, this feature is no longer included in your subscription plan.">
                                    <div className="lock-wrapper">
                                        <IconSolidLock />
                                    </div>
                                </Tooltip>
                            }
                            {!integration.isShipping &&
                                <div className='ui-actions-wrapper'>
                                    <Toggle
                                        checked={integration.isEnabled}
                                        label=""
                                        onChange={v => integration?.setIsEnabled(v)}
                                        disabled={!integration.isAllowed}
                                    />
                                </div>
                            }
                        </>
                    )
                }}
                note={integration.description}
                isExpandable={isExpandable}
                isExpanded={isExpanded}
            >
                {!integration.isAllowed && <ActionsDisabledOverlay />}
                {/* the form element is used only to suppress chromes warning "Password field is not contained in a form.." */}
                <form onSubmit={(e) => { e.preventDefault(); }}>
                    <div className='integration-content'>
                        {integration.id ?
                            getConnectedLayout(integration, vGroup)
                            :
                            getSpecificComponent(integration, vGroup)
                        }
                        {isInventoryTrackingNoteVisible && <InventoryTrackingConnectionNote />}
                        { !integration.id && integration.isSandboxModeAvailable && <IsSandboxField onChange={integration.setIsSandbox} isSandbox={integration.isSandbox}/>}
                        {!integration.id &&
                            <Button
                                text={'CONNECT'}
                                variant={BUTTON_VARIANTS.Primary}
                                onClick={onConnect}
                                isLoading={integration.isLoading}
                                hasLoader
                                disabled={(!vGroup.isValid() && !integration.id) || isButtonDisabled || integration.isLoading}
                            />}
                    </div>
                </form>
            </Card>
            {isShowDeleteConfirmModal &&
                <ActionConfirmModal
                    integration={integration}
                    title='delete'
                    onOkClick={onDeleteConfirm}
                    onCancelClick={() => setIsShowDeleteConfirmModal(false)}
                />
            }
            {isShowForgetConfirmModal &&
                <ActionConfirmModal
                    integration={integration}
                    title='disconnect'
                    onOkClick={onForgetConfirm}
                    onCancelClick={() => setIsShowForgetConfirmModal(false)}
                />
            }
            {isShowNotificationModal &&
                <NotificationModal
                    title='Integrations - Apps & Services'
                    text={<div
                        dangerouslySetInnerHTML={{ __html: integration.deleteInfo.message || "The integration can't be deleted/disconnected" }}
                    />}
                    okButton={{
                        title: 'Close',
                        onClick: () => setIsShowNotificationModal(false),
                    }}
                />
            }
            {isShowStripeModal &&
                <NotificationModal
                    title='Integrations - Apps & Services'
                    text={<p>
                        Connection failed. The Stripe account activation process is not completed.<br></br>
                        Please activate your Stripe account on <a rel="noreferrer" href='http://stripe.com/' target='_blank'>Stripe.com</a> and try again. <br />
                        <a rel="noreferrer" href='https://support.returngo.ai/integration-with-stripe' target='_blank'>Learn more</a>
                    </p>}
                    okButton={{
                        title: 'Close',
                        onClick: () => setIsShowStripeModal(false),
                    }}
                />
            }
        </>
    );
});

export default IntegrationCard;
